// extracted by mini-css-extract-plugin
export default {"pills":"SummaryPills_pills__W1lcn","pill":"SummaryPills_pill__k-nas","pill-label":"SummaryPills_pill-label__YC9fk","pill-value":"SummaryPills_pill-value__7z0TD"};